import type { Options, RetryFunction } from 'async-retry';
import asyncRetry from 'async-retry';

const RETRY_OPTIONS = {
  // retries means N tries after the first time, for a total of N + 1 attempts
  retries: 4,
  minTimeout: 200,
};

export async function retry(resolver: RetryFunction<any>, options: Options = {}): Promise<any> {
  return asyncRetry(resolver, { ...RETRY_OPTIONS, ...options });
}
